module.exports = __webpack_public_path__ + "assets/img/recordIcon3.845e097d.png";